
<div data-spy="scroll" data-target="#component-list" data-offset="0" id="mainContent">
    <router-outlet></router-outlet>
</div>

